export default "__VITE_ASSET__BSqw9iti__"